import * as moment from "moment";
import { roundAwayFromZero } from "./math-functions";

export function formatToHHmmss_ss(seconds: number): string {
    return formatToHHmmss_x(seconds, Magnitude.Hundredths)
}

const hourMinuteSecThousandsOfSecRegex = /([0-9][0-9]):[0-5][0-9]:[0-5][0-9]\.[0-9][0-9][0-9]/;

export function formatToHHmmss_sss(seconds: number): string {
    return formatToHHmmss_x(seconds, Magnitude.Thousandths)
}

export enum Magnitude {
    Thousandths = 1000,
    Hundredths = 100
}

function formatToHHmmss_x(seconds: number, magnitude: Magnitude): string {
    const xths = roundAwayFromZero(seconds * magnitude - Math.floor(seconds) * magnitude);
    seconds = Math.floor(seconds);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);

    const result = [];

    result.push(hours);
    result.push(minutes % 60);
    result.push(seconds % 60);

    for (let i = 0; i < result.length; i++) {
        const x = result[i];

        if (x < 10) {
            result[i] = "0" + x;
        } else {
            result[i] = x;
        }
    }

    let resultString = result.join(":");

    let xthString: string | number;
    if (xths < 10) {
        xthString = magnitude === Magnitude.Thousandths ? "00" + xths : "0" + xths;
    } else if (magnitude === Magnitude.Thousandths && xths < 100) {
        xthString = "0" + xths;
    } else {
        xthString = xths;
    }

    resultString += "." + xthString;

    return resultString;
}

export function subtractFormattedTimesWithThousandsOfSec(
    timeLater: string,
    timeSooner: string
): string {
    if (
        !hourMinuteSecThousandsOfSecRegex.test(timeLater) ||
        !hourMinuteSecThousandsOfSecRegex.test(timeSooner)
    ) {
        throw new Error("Invalid time format of one of the passed time arguments.");
    }

    const [tLater, hunLaterStr] = timeLater.split(".");
    const [tSooner, hunSoonerStr] = timeSooner.split(".");
    const [hLater, minLater, secLater] = tLater.split(":").map(Number);
    const [hSooner, minSooner, secSooner] = tSooner.split(":").map(Number);

    const hunLater = Number(hunLaterStr);
    const hunSooner = Number(hunSoonerStr);

    const decrementSeconds = hunLater < hunSooner;
    const hDiff = hunLater - hunSooner + (decrementSeconds ? 1000 : 0);

    const momLater = moment()
        .utc()
        .startOf("day")
        .hour(hLater)
        .minute(minLater)
        .second(secLater);

    const momSooner = moment()
        .utc()
        .startOf("day")
        .hour(hSooner)
        .minute(minSooner)
        .second(secSooner);

    const momLaterDiffSooner = moment(momLater.diff(momSooner)).utc();

    if (decrementSeconds) {
        momLaterDiffSooner.second(momLaterDiffSooner.second() - 1);
    }

    let prefix = "";
    if (hDiff < 10) {
        prefix = "00";
    } else if (hDiff < 100) {
        prefix = "0";
    }

    return `${momLaterDiffSooner.format("HH:mm:ss")}.${prefix}${hDiff}`;
}

export const HHmmssToTotalSeconds = (time: string) => {
    return moment.duration(time).asSeconds();
}

export const isoToHHmmss = (timeISO: string): string => {
    if (!timeISO) return null;

    return moment.duration(timeISO).format("HH:mm:ss", { trim: false });
}
